import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createCardBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/layoutBlockHelpers";
import bulbImagePlaceholder from "../../CallToAction/CardCallToAction/bulb_image_placeholder.png";
import checkImagePlaceholder from "../../CallToAction/CardCallToAction/check_image_placeholder.png";
import communityImagePlaceholder from "../../CallToAction/CardCallToAction/community_image_placeholder.png";
import graphImagePlaceholder from "../../CallToAction/CardCallToAction/graph_image_placeholder.png";
import usersImagePlaceholder from "../../CallToAction/CardCallToAction/users_image_placeholder.png";
import worldImagePlaceholder from "../../CallToAction/CardCallToAction/world_image_placeholder.png";
import { getSalesBlockSecondaryStyleOptions } from "../../Sales/constants";
import { createH2Block } from "../../utils/textBlocksHelpers";

const cards = [
  {
    image: {
      signedId: "",
      placeholder: usersImagePlaceholder,
    },
    h5Text: "Empowering Leaders",
    pText:
      "We equip individuals with the confidence, skills, and strategies to lead effectively and make meaningful decisions.",
  },
  {
    image: {
      signedId: "",
      placeholder: communityImagePlaceholder,
    },
    h5Text: "Community Building",
    pText:
      "We create a supportive network where leaders connect, collaborate, and grow together through shared experiences and insights.",
  },
  {
    image: {
      signedId: "",
      placeholder: graphImagePlaceholder,
    },
    h5Text: "Ongoing Growth",
    pText:
      "Our evolving coaching programs ensure leaders stay ahead with relevant knowledge, new strategies, and lifelong development.",
  },
  {
    image: {
      signedId: "",
      placeholder: bulbImagePlaceholder,
    },
    h5Text: "Coaching Innovation",
    pText:
      "We integrate modern techniques and data-driven insights to deliver impactful coaching that drives real leadership transformation.",
  },
  {
    image: {
      signedId: "",
      placeholder: worldImagePlaceholder,
    },
    h5Text: "Expanding Our Reach",
    pText:
      "We strive to make leadership coaching accessible worldwide through digital platforms, expert-led sessions, and vibrant communities.",
  },
  {
    image: {
      signedId: "",
      placeholder: checkImagePlaceholder,
    },
    h5Text: "Sustained Impact",
    pText:
      "Our focus is on long-term leadership success, ensuring every leader experiences lasting personal and professional growth.",
  },
] as const;

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "AboutUsBlock2",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Our Vision for The Future",
        }),
      ],
    },
    content: {
      prop: "children",
      type: "children",
      value: cards.map(card => createCardBlock(card)),
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getSalesBlockSecondaryStyleOptions(),
      },
    },
  },
};
